module.exports = __webpack_public_path__ + "d45bdbc2d4a98c1ecb17821a1dbbd3a4.ttf";